import { actionTypes, errorTypes } from '@/types';
import { uiComponents } from '@/tools/viewState';

export default function isValidModalId(id, dispatch) {
	if (!Object.values(uiComponents).includes(id)) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.viewStateUnknownUiComponent) });
		return false;
	}
	return true;
}
